import React, {useEffect} from 'react';
import {Dialog} from "../../fusion-ui";

/**
 * Create a theme based dialog.
 *
 * @example
 *      const [openDialog, setOpenDialog] = useState(false);
 *      const [emailInputMsg, setEmailInputMsg] = useState('');
 *
 *        <ThemedDialog
 *             open={openDialog}
 *             title={'Dialog Title'}
 *             widthClass={'col-sm-12 col-md-8'}
 *             height={'auto'}
 *             maxHeight={'auto'}
 *             showClose={true}
 *             closeOnOutsideClick={true}
 *             showFooter={true}
 *             closeOnEscape={true}
 *             showCancelControl={false}
 *             showConfirmControl={true}
 *             cancelText={'Cancel'}
 *             confirmText={'Close'}
 *             onHide={() => {
 *                 setOpenDialog(false);
 *             }}
 *             onConfirm={() => { }}
 *             onCancel={() => { }}
 *             onClose={() => { }}>
 *          <div>children goes here</div>
 *        </Dialog>
 */
const ThemedDialog = React.memo(({
                                     open,
                                     contentClassName = "",
                                     titleClassName = "",
                                     footerClassName = "",
                                     headerClassName = "",
                                     widthClass = "col-sm-12 col-md-8",
                                     controlsAt = "end",
                                     titleAt = "center",
                                     title,
                                     children,
                                     showHeader = true,
                                     showClose = true,
                                     sleekControl = true,
                                     scrolled = true,
                                     closeOnEscape = true,
                                     onEscapeClose,
                                     onOutsideClick,
                                     closeOnOutsideClick = true,
                                     showConfirmControl = true,
                                     showCancelControl = false,
                                     showFooter = true,
                                     height = 'auto',
                                     maxHeight = 'auto',
                                     confirmText = 'Confirm',
                                     cancelText = 'Cancel',
                                     cancelClassName = '',
                                     confirmClassName = '',
                                     disableConfirm,
                                     disableCancel,
                                     onHide,
                                     onConfirm,
                                     onCancel,
                                     onClose,
                                     ...rest
                                 }) => {
    const TAG = "ThemedDialog";

    useEffect(() => {

    }, []);
    useEffect(() => {

    }, [children]);

    return (<Dialog
        open={open}
        title={title}
        contentClassName={contentClassName}
        showHeader={showHeader}
        height={height}
        maxHeight={maxHeight}
        widthClass={widthClass}
        className={"p-0"}
        titleClassName={`fs-normal fw-bold ${titleClassName}`}
        footerClassName={`p-2x ${footerClassName}`}
        headerClassName={`pt-3 ${headerClassName}`}
        controlsAt={controlsAt}
        titleAt={titleAt}
        scrollVariant={"dark"}
        sleekControl={sleekControl}
        scrolled={scrolled}
        closeOnEscape={closeOnEscape}
        closeOnOutsideClick={closeOnOutsideClick}
        onEscapeClose={onEscapeClose}
        onOutsideClick={onOutsideClick}
        showCancelControl={showCancelControl}
        showConfirmControl={showConfirmControl}
        showFooter={showFooter}
        showClose={showClose}
        confirmText={confirmText}
        cancelText={cancelText}
        onHide={onHide}
        onCancel={onCancel}
        onClose={onClose}
        onConfirm={onConfirm}
        cancelClassName={cancelClassName}
        confirmClassName={confirmClassName}
        disableConfirm={disableConfirm}
        disableCancel={disableCancel}
        {...rest}
    > {children}
    </Dialog>)

    function fun() {

    }
});
export default ThemedDialog;
